<template>
  <!-- 对齐 App coupon.dart：AppHeader + 白色 Card（顶部圆角 30 + 10.w 上边距）+ 列表/空态 + 底部"Add a Promo Code"入口 -->
  <div class="coupons-page">
    <app-header :title="i18n.title"></app-header>

    <div class="coupons-card">
      <!-- 优惠券列表 -->
      <div v-if="items.length > 0" class="coupons-list">
        <div v-for="item in items" :key="item.id || item.pid" class="coupon-item">
          <div class="coupon-item-left">
            <div class="coupon-item-value">{{ item.pMian }}</div>
            <div class="coupon-item-unit">{{ i18n.min }}</div>
          </div>
          <div class="coupon-item-right">
            <div class="coupon-item-name">{{ item.ruleName }}</div>
            <div class="coupon-item-expires">
              {{ i18n.expires }}: {{ item.pEnd }}
            </div>
          </div>
        </div>
      </div>

      <!-- 空态撑开（让底部按钮居中） -->
      <div v-else class="coupons-empty-spacer"></div>

      <!-- 底部"Add a Promo Code"入口（对齐 App 截图：橙色 + 图标 + 标题 + 副标题） -->
      <div class="coupons-add" @click="onShowCodeDialog">
        <img class="coupons-add-icon" src="../../assets/imgs/icon_add_2.png" alt="" />
        <div class="coupons-add-title">{{ i18n.add_promo_code }}</div>
        <div class="coupons-add-tips">{{ i18n.tip_refer_friend }}</div>
      </div>
    </div>

    <!-- 添加优惠码弹窗（对齐 App coupon.dart showCodeDialog L471-570） -->
    <van-popup
      v-model="showCodeDialog"
      position="bottom"
      round
      :close-on-click-overlay="true"
      :style="{ background: '#fff' }"
    >
      <div class="coupons-dialog">
        <div class="coupons-dialog-handle"></div>
        <div class="coupons-dialog-title">{{ i18n.add_promo_code }}</div>
        <div class="coupons-dialog-input">
          <input
            v-model="promoCode"
            class="coupons-dialog-field"
            type="text"
            :placeholder="i18n.code_placeholder"
          />
        </div>
        <div class="coupons-dialog-submit" @click="onSubmitCode">
          {{ i18n.add_promo_code }}
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import AppHeader from "../../components/common/AppHeader.vue"

export default {
  components: {
    AppHeader
  },
  data() {
    return {
      // 暂时没有后端接口，留空数组走空态
      items: [],
      showCodeDialog: false,
      promoCode: ""
    }
  },
  computed: {
    i18n() {
      return this.$t("coupon")
    }
  },
  methods: {
    onShowCodeDialog() {
      this.promoCode = ""
      this.showCodeDialog = true
    },
    onSubmitCode() {
      // H5 端暂未对接 exchangeInviteCode/sendCoupon API
      if (!this.promoCode) {
        this.$toast(this.i18n.code_placeholder)
        return
      }
      this.$toast(this.i18n.msg_success)
      this.showCodeDialog = false
    }
  }
}
</script>

<style lang="less">
/* 对齐 App coupon.dart：
   pageBackgroundColor = white, cardColor = white（顶部圆角 30 + 10.w 上边距） */
.coupons-page {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background: #fff;
  display: flex;
  flex-direction: column;
}

.coupons-card {
  flex: 1;
  background: #fff;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  margin-top: 17px;
  display: flex;
  flex-direction: column;
}

.coupons-list {
  flex: 1;
  padding: 30px 40px;
  overflow-y: auto;
}

/* coupon item: 76.w 高 ≈ 133px, 圆角 16, itemColor 背景 */
.coupon-item {
  display: flex;
  align-items: center;
  height: 133px;
  margin-bottom: 35px;
  background: #f8f6fc;
  border-radius: 28px;
  overflow: hidden;
  box-sizing: border-box;
}

.coupon-item-left {
  width: 173px; /* 99.w */
  background: #ff8800; /* themeColor */
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.coupon-item-value {
  font-size: 46px; /* 26.sp ≈ 46px */
  font-weight: 700;
  font-family: "Montserrat-SemiBold", sans-serif;
  line-height: 1.1;
}

.coupon-item-unit {
  font-size: 18px;
  opacity: 0.7;
  line-height: 1.2;
}

.coupon-item-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
}

.coupon-item-name {
  font-size: 36px; /* 20.sp ≈ 35px */
  font-weight: 700;
  color: #000;
  font-family: "Montserrat-SemiBold", sans-serif;
  text-align: center;
}

.coupon-item-expires {
  margin-top: 10px;
  font-size: 18px;
  color: #000;
  text-align: center;
}

/* 空态撑开：让底部按钮居中显示（对齐 App 截图） */
.coupons-empty-spacer {
  flex: 1;
}

/* 底部"Add a Promo Code"入口：橙色 + 图标 + 标题 + 副标题，全部居中 */
.coupons-add {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 30px 80px;
  cursor: pointer;
}

.coupons-add-icon {
  width: 120px; /* 92.w */
  height: 120px;
  display: block;
}

.coupons-add-title {
  margin-top: 35px; /* 30.w */
  font-size: 36px; /* 24.sp */
  font-weight: 700;
  color: #000;
  font-family: "Montserrat-SemiBold", sans-serif;
  text-align: center;
}

.coupons-add-tips {
  margin-top: 15px;
  font-size: 18px;
  color: #000;
  text-align: center;
}

/* 弹窗（对齐 App coupon.dart showCodeDialog） */
.coupons-dialog {
  background: #fff;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  padding: 30px 0 40px;
}

.coupons-dialog-handle {
  width: 80px;
  height: 8px;
  margin: 0 auto 80px;
  background: #f8f6fc;
  border-radius: 8px;
}

.coupons-dialog-title {
  padding: 0 40px;
  font-size: 36px;
  font-weight: 700;
  color: #000;
  font-family: "Montserrat-SemiBold", sans-serif;
  text-align: left;
}

.coupons-dialog-input {
  margin: 35px 52px 60px;
  height: 105px; /* 60.w */
  padding: 0 35px;
  border: 1px solid #d5d5d5;
  border-radius: 18px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

.coupons-dialog-field {
  flex: 1;
  height: 100%;
  font-size: 32px;
  color: #000;
  border: none;
  outline: none;
  background: transparent;
}

.coupons-dialog-submit {
  margin: 0 40px;
  height: 105px;
  background: #ff8800;
  color: #fff;
  font-size: 32px;
  font-weight: 700;
  font-family: "Montserrat-SemiBold", sans-serif;
  text-align: center;
  line-height: 105px;
  border-radius: 18px;
  cursor: pointer;
}
</style>
